var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Button from "@irati/ui/src/Button";
import { FormattedMessage } from "@irati/utils/lang";
import { homepageTracking } from "@irati-tracking/platform";
import { EditWidgetWrapper, EditButtons, ConfirmationModal } from "./styled/styled";
var EditWidget = /** @class */ (function (_super) {
    __extends(EditWidget, _super);
    function EditWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showConfirmationModal: false
        };
        _this.getWidgetObject = function () {
            var _a = _this.props, widgetId = _a.widgetId, image = _a.image, link = _a.link, header = _a.header, body = _a.body, type = _a.type, openLinkInNewTab = _a.openLinkInNewTab, videoUrl = _a.videoUrl;
            return {
                i: widgetId,
                image: image,
                type: type,
                link: link,
                header: header,
                body: body,
                openLinkInNewTab: openLinkInNewTab,
                videoUrl: videoUrl
            };
        };
        _this.handleShowConfirmationModal = function () {
            _this.setState({ showConfirmationModal: true });
            var widget = _this.getWidgetObject();
            homepageTracking.startDeleteTile(widget);
        };
        _this.handleHideConfirmationModal = function () {
            _this.setState({ showConfirmationModal: false });
        };
        _this.handleEditTile = function () {
            var editTile = _this.props.editTile;
            var widget = _this.getWidgetObject();
            homepageTracking.startEditTile(widget);
            editTile(widget);
        };
        return _this;
    }
    EditWidget.prototype.render = function () {
        var _a = this.props, widgetId = _a.widgetId, removeTileFromGrid = _a.removeTileFromGrid;
        var showConfirmationModal = this.state.showConfirmationModal;
        return (React.createElement(EditWidgetWrapper, null,
            React.createElement(EditButtons, { icon: "editPencil", onClick: this.handleEditTile }),
            React.createElement(EditButtons, { icon: "trashcan", onClick: this.handleShowConfirmationModal }),
            showConfirmationModal &&
                React.createElement(ConfirmationModal, { show: showConfirmationModal },
                    React.createElement(Modal.Header, null,
                        React.createElement("h4", null,
                            React.createElement(FormattedMessage, { id: "home.feed.deleteWidget.confirmation" }))),
                    React.createElement(Modal.Body, { id: "example-modal-sizes-title-lg" },
                        React.createElement(Button, { onClick: this.handleHideConfirmationModal }, "Cancel"),
                        React.createElement(Button, { primary: true, onClick: function () { return removeTileFromGrid(widgetId); } }, "Confirm")))));
    };
    return EditWidget;
}(Component));
export default EditWidget;
